import React, { useEffect, useState } from "react";
import UsersDataTable from "../components/data-tables/UsersDataTable";
import { API } from "../assets/staticData";
import AddUser from "../components/add-user/AddUser";
import EditUser from "../components/editors/EditUser";
import usePermission from "../hooks/use-permission";

export default function Admin({
  user
}) {
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState([]);
  const [addUser, setAddUser] = useState(false);
  const [editUser, setEditUser] = useState(false);

  const { hasPermission } = usePermission()

  let token = process.env.REACT_APP_ADMIN_TOKEN;

  useEffect(() => {
    async function getData() {
      fetch(`${API}/users`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(async (res) => {
        const respone = await res.json();
        setData(respone);
      });
    }

    getData();
  }, [refresh]);

  return (
    <div>
      <div
        className="flex mb-4"
        style={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <h3>Admin Settings</h3>

        <div
          onClick={() => setAddUser(true)}
          className="bg-blue-500 px-3 py-2 rounded-md text-white hover:bg-blue-600 transition-all delay-100 cursor-pointer"
        >
          Add New User
        </div>
      </div>

      <UsersDataTable
        data={data}
        refresh={refresh}
        user={user}
        setRefresh={setRefresh}
        endpoint={"users"}
        setEditUser={setEditUser}
      />

      <AddUser
        show={addUser}
        setShow={setAddUser}
        refresh={refresh}
        setRefresh={setRefresh}
      />
    </div>
  );
}
